import * as React from 'react';
import {
  IconProps,
  IconSvgWrapper,
} from '@grnhse/seedling/lib/birch/icons/base';
import { IconTheme } from '@grnhse/seedling/lib/birch/icons/theme';

const BookmarkIcon = (props: IconProps) => {
  const { color = IconTheme.default.color } = props;
  return (
    <IconSvgWrapper {...props}>
      <path
        // eslint-disable-next-line max-len
        d="M6.5 4.75H17.7227C17.8605 4.75023 17.9727 4.86207 17.9727 5V18.9902C17.9724 19.1965 17.7359 19.3139 17.5713 19.1895L13.167 15.8584C12.5425 15.3861 11.6802 15.3861 11.0557 15.8584L6.65039 19.1895C6.48581 19.3135 6.25025 19.1964 6.25 18.9902V5C6.25 4.86193 6.36193 4.75 6.5 4.75Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </IconSvgWrapper>
  );
};

export default BookmarkIcon;
